// Imports for external libraries go here.
import React, { FC } from 'react';
import { LinksCollection, Modal, useWindowSize } from '@marriott/mi-ui-library';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { LanguageSelectorProps } from './LanguageSelector.types';
import { StyledLanguageSelector, StyledModalHeader, StyledModalBody, StyledBorder } from './LanguageSelector.styles';

// Use named rather than default exports.
export const LanguageSelector: FC<LanguageSelectorProps> = (props: LanguageSelectorProps) => {
  const { width } = useWindowSize();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  type JsonArray = any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  type JsonObject = { [key: string]: any };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isObject = (o: any): o is object => typeof o === 'object' && o !== null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const sortJSON = (o: string): any => {
    if (Array.isArray(o)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return o.sort().map((item: any) => sortJSON(item)) as JsonArray;
    } else if (isObject(o)) {
      return Object.keys(o)
        .sort()
        .reduce((acc: JsonObject, key: string) => {
          acc[key] = sortJSON(o[key]);
          return acc;
        }, {}) as JsonObject;
    }
    return o;
  };

  const regionData = Object.values(sortJSON(props?.languageSelectorModal.langNavList || {}));
  return (
    <StyledLanguageSelector
      data-testid="luxury-LanguageSelector"
      data-component-name="m-luxury-LanguageSelector"
      ref={props?.langSelectorRef}
    >
      <div className="language-selector">
        {props?.languageSelectorModal && props?.languageSelectorModal?.langNavList && props?.isOpen && (
          <Modal
            className="modal-popup-container"
            secondaryClassName="modal-main-container"
            show={props?.isOpen}
            popupOpenState={props?.isOpen}
            handleBlur={true}
            setPopupOpenState={props?.setIsOpen as () => void}
            disableScrollOnBody={true}
          >
            <StyledModalHeader
              className="modal-header px-4"
              labelText={props?.languageSelectorModal?.languageSelectorTitle}
              popupHeaderOnCLoseFunc={props?.setIsOpen as () => void}
            ></StyledModalHeader>

            <StyledModalBody className="modal-body">
              {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                regionData?.map((column: any, index: number) => (
                  <div key={index} className="col-12 col-sm-4 col-lg-4 custom-header-font">
                    {Object.keys(column)?.map((title, idx) => (
                      <div key={idx}>
                        <LinksCollection
                          {...column}
                          linkListData={column && column[title]}
                          heading={title
                            .replace('-', ' ')
                            .split('')
                            .map((char, index) => (index === 0 ? char.toUpperCase() : char))
                            .join('')}
                          headingClassName={`region-header pt-4 t-subtitle-xl header-${title}`}
                          listCollectionClassname="custom-link"
                          listItemClassName="py-3"
                          hasIconArrow={false}
                          key={title}
                        />
                        {width && width <= 575 && <StyledBorder className={`mobile-border-${index}`} />}
                      </div>
                    ))}
                  </div>
                ))
              }
            </StyledModalBody>
          </Modal>
        )}
      </div>
    </StyledLanguageSelector>
  );
};
